<template>
  <el-card shadow="never"
    ><el-page-header @back="goBack"> </el-page-header>
    <el-divider></el-divider>
    <div class="course-introduce">
      {{ course_id }}{{ course_name }}{{ course_cover }}{{ course_info
      }}{{ member_discount }}课程介绍
    </div>
    <el-button @click="addCourseSection" size="mini" type="primary"
      >添加内容</el-button
    >
    <!-- 内容列表 -->
    <div v-loading="loading">
      <el-table :data="course_data" style="width: 100%">
        <el-table-column prop="section_id" label="ID" width="40">
        </el-table-column>
        <el-table-column prop="section_name" label="名称" width="180">
        </el-table-column>
        <el-table-column prop="chapter_name" label="所属章节" width="180">
        </el-table-column>
        <el-table-column prop="update_time" label="创建日期"> </el-table-column>
        <el-table-column prop="update_time" label="操作">
          <template slot-scope="operator">
            <el-link
              @click="manageCourseConent(operator.row)"
              :underline="false"
              >查看</el-link
            >
            ｜
            <el-link
              @click="renewCourseSection(operator.row)"
              :underline="false"
              >编辑</el-link
            >
            ｜<el-link :underline="false">分享</el-link> ｜<el-link
              :underline="false"
              >下线</el-link
            >
          </template>
        </el-table-column>
        <el-table-column prop="open" label="是否免费">
          <template slot-scope="operator">
            <el-switch
              v-model="operator.row.is_open"
              active-color="#13ce66"
              inactive-color="#D1D1D1"
              @change="clickSwitchButton(operator)"
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { tpx_app } from "../../network/request";
export default {
  name: "course-content-manage",
  data() {
    return {
      loading: true,
      course_id: 0,
      course_name: "",
      course_cover: "",
      course_info: "",
      is_online: false,
      member_discount: false,
      course_data: [], //单个课程所有数据
      // 课程是否免费
      statusFree: false,
    };
  },
  mounted() {
    if (this.$route.query.course_id) {
      this.course_id = this.$route.query.course_id;
      // 请求课程详细内容
      this.getAllCourseContent(this.course_id);
    } else {
      this.$router.push({ name: "course" });
    }
  },

  methods: {
    //
    clickSwitchButton(value) {
      let is_open;
      if (value.row.is_open == true) {
        is_open = 0;
      } else {
        is_open = 1;
      }
      console.log(is_open);
      this.$http
        .get(
          `/change_status_section_open?status=${is_open}&section_id=${value.row.section_id}`
        )
        .then((res) => {
          const { errno, errmsg } = res.data;
          if (errno == "0") {
            this.$notify({
              title: "成功",
              message: errmsg,
              type: "success",
            });
          }
        });
    },
    manageCourseConent(value) {
      // console.log(value);
      this.$router.push({
        path: "/content_and_modify",
        query: {
          section_id: value.section_id,
          section_name: value.section_name,
          chapter_id: value.chapter_id,
          chapter_name: value.chapter_name,
          course_name: this.course_name,
          course_id: this.course_id,
        },
      });
    },
    goBack() {
      this.$router.push({ name: "course" });
    },
    addCourseSection() {
      this.$router.push({
        name: "creat_new_section",
        params: {
          course_id: this.course_id,
        },
      });
    },
    getAllCourseContent(course_id) {
      this.loading = true;
      tpx_app({
        url: "get_course_all_section",
        params: {
          course_id: course_id,
        },
      }).then((res) => {
        // console.log(res);
        const { errno, errmsg, data } = res.data;
        if (errno == "0") {
          this.course_data = data.section;
          this.course_name = data.course_name;
          this.course_cover = data.course_cover;
          this.course_info = data.course_info;
          this.is_online = data.is_online;
          this.member_discoun = data.member_discoun;
          this.loading = false;
        }
      });
    },
    // 修改课程内容
    renewCourseSection(value) {
      this.$router.push({
        name: "re_new_section",
        params: {
          course_id: this.course_id,
          section_name: value.section_name,
          section_id: value.section_id,
          chapter_name: value.chapter_name,
          chapter_id: value.chapter_id,
          author: value.author,
          section_cover: value.section_cover,
          section_intro: value.section_intro,
        },
      });
    },
  },
};
</script>

<style>
.course-introduce {
  background-color: whitesmoke;
  border-radius: 10px;
  padding: 20px;
  height: 50px;
  margin-bottom: 40px;
}
</style>